import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, SUPPORTED_LOCALES } from "./translations";

const LanguageContext = createContext(null);

const getInitialLocale = () => {
 if (typeof window === "undefined") return "fr";
 const saved = window.localStorage.getItem("nanda-locale");
 if (saved && SUPPORTED_LOCALES.includes(saved)) return saved;
 // Brand origin is French — default everyone to FR. Users can switch.
 return "fr";
};

const resolveKey = (dict, key) => {
 if (!key) return "";
 return key.split(".").reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : null), dict);
};

export const LanguageProvider = ({ children }) => {
 const [locale, setLocale] = useState(getInitialLocale);

 useEffect(() => {
 if (typeof window !== "undefined") {
 window.localStorage.setItem("nanda-locale", locale);
 // Le tag lang et les meta sont maintenant gérés par <Seo /> (composant centralisé).
 // Ici on maintient uniquement la persistance de la préférence utilisateur.
 }
 }, [locale]);

 const value = useMemo(() => {
 const dict = translations[locale] || translations.fr;
 const t = (key, fallback = "") => {
 const v = resolveKey(dict, key);
 if (v === null || v === undefined) return fallback || key;
 return v;
 };
 return { locale, setLocale, t, locales: SUPPORTED_LOCALES };
 }, [locale]);

 return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
 const ctx = useContext(LanguageContext);
 if (!ctx) throw new Error("useLanguage must be used inside LanguageProvider");
 return ctx;
};
